import React from "react";

export default function RequiredFieldMarker() {
  return (
    <span aria-hidden="true" className="text-red-600">
      {" "}
      *
    </span>
  );
}
